import { Box } from '@mui/material'
import { ChevronRight16Regular } from '@/components/Icon'
import { LEAD_ICON_SIZE } from './agentReplyPreambleTokens'

/**
 * Chevron: collapsed ≈ down (90deg), expanded per Figma (−180deg).
 * @param {{ expanded?: boolean, interactive?: boolean }} props
 */
export function AgentReplyLeadIcon({ expanded = false, interactive = false }) {
  return (
    <Box
      sx={{
        width: LEAD_ICON_SIZE,
        height: LEAD_ICON_SIZE,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.primary',
        transform: expanded ? 'rotate(-180deg)' : 'rotate(90deg)',
        transition: interactive ? 'transform 160ms ease' : undefined,
        '& svg': {
          display: 'block',
          fill: 'currentColor',
          width: LEAD_ICON_SIZE,
          height: LEAD_ICON_SIZE,
        },
      }}
      aria-hidden
    >
      <ChevronRight16Regular primaryFill="currentColor" />
    </Box>
  )
}
